import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import axios from 'axios';
import {bffUrl} from './config.js';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withSnackbar} from 'notistack';
import qs from "qs";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {getSupportUsers} from "./actions/supportUserActions";
import {connect} from "react-redux";
import ErrorBoundary from "./ErrorBoundry";

const styles = {
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    container: {
        position: 'relative',
    },
    card: {
        minWidth: 75,
        backgroundColor: "#DCDCDC",
        marginTop: "10px"
    },
    bullet: {
        display: "inline-block",
        margin: "0 2px",
        transform: "scale(0.8)",
    },
    title: {
        fontSize: 20,
        color: "#FF0000",
        textAlign: "center"
    },
    pos: {
        marginBottom: 12
    }
};

const jobCodeOptions = [
    {
        name: 'XCODE_BASIC',
        key: 'XCODE_BASIC',
        label: 'XCODE_BASIC',
    },
    {
        name: 'VP6',
        key: 'VP6',
        label: 'VP6',
    },
    {
        name: 'VP9',
        key: 'VP9',
        label: 'VP9',
    },
    {
        name: 'NP6320',
        key: 'NP6320',
        label: 'NP6320',
    },
    {
        name: 'UST_VP6',
        key: 'UST_VP6',
        label: 'UST_VP6',
    },
    {
        name: 'UST_VP9',
        key: 'UST_VP9',
        label: 'UST_VP9',
    },
    {
        name: 'GMN',
        key: 'GMN',
        label: 'GMN',
    }
];

const SUCCESS = "success";
const WARNING = "warning";
const ERROR = "error";

class TranscodingTriggerTool extends Component {

    state = {
        cid: this.cid,
        checkedItems: new Map(),
        showLoading: false
    };

    constructor(props) {
        super(props);

        let parsed = qs.parse(this.props.location.search);

        if (parsed["?cids"] && parsed["?cids"].length > 0) {
            this.state.cid = parsed["?cids"];
        } else {
            this.state.cid = "";
        }

    }

    handleChange = element => event => {
        this.setState({
            [element]: event.target.value,
        }, function () {

        });
    };

    checkBoxHandleChange = e => {
        const item = e.target.value;
        const isChecked = e.target.checked;
        this.setState(prevState => ({checkedItems: prevState.checkedItems.set(item, isChecked)}));
    };

    makeAllCheckBoxToFalse = () => {
        console.log("make all false");
        let self = this;
        this.state.checkedItems.forEach(function (value, key) {
            self.setState({
                checkedItems: self.state.checkedItems.set(key, false)
            }, () => {
                console.log(self.state.checkedItems);
            })
        });

    };

    componentDidMount = () => {

    };


    stateChangeHandler = () => {
        // make cid empty and showLoading to false
        this.setState({
            cid: '',
            showLoading: false
        })
    };

    snackbarHandler = (msg, type) => {
        this.props.enqueueSnackbar(`${msg}`, {
            variant: `${type}`, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }
        });
    };

    triggerTranscodingForCid = event => {
        console.log("inside function");
        console.log(this.state.checkedItems);
        var jobCodeArray = [];
        var triggerTranscodeForCidsUrl = `${bffUrl}/video/triggerTranscoding?userEmail=${sessionStorage.userEmail}`;

        if (this.state.cid !== null) {

            const {cid} = this.state;
            var cids = cid.split(",");
            cids = cids.map(s => s.trim());

            if (Object.keys(cids).length > 50) {
                alert("Enter Maximum 50 cids");
                this.setState({
                    cid: '',
                });
                return false;
            }

            console.log(cids);
            this.state.checkedItems.forEach(function (value, key) {
                // console.log(key + ' = ' + value);
                if (value) {
                    jobCodeArray.push(key);
                }
            });

            if (Object.keys(jobCodeArray).length > 0) {
                console.log(cids);
                console.log(jobCodeArray);
                this.setState({
                    showLoading: true
                });

                axios.post(triggerTranscodeForCidsUrl, {
                    // array of cid and array of jobcode
                    cids: cids,
                    jobCode: jobCodeArray
                })
                    .then((response) => {
                        console.log(response.data);
                        this.stateChangeHandler();
                        this.snackbarHandler('Success in Request for transcoding !!!', SUCCESS);
                        // // const [ state, result ] = response.data;
                        // console.log(response.data["state"]);
                        // console.log(response.data["result"].failureCids.length);
                        // console.log(response.data["result"].successCids);

                        // if(response.data["state"]) {
                        //     if(response.data["result"].successCids.length > 0 ) {
                        //         this.snackbarHandler(`Successful transcoding Request for cids are :: ${response.data["result"].successCids} !!!`,SUCCESS);
                        //     }
                        // }
                    }).catch((error) => {
                    this.stateChangeHandler();
                    this.snackbarHandler('Error While Processing Transcoding !!!', ERROR);
                });
            } else {
                this.stateChangeHandler();
                this.snackbarHandler('Please Select any Jobcode First', WARNING);
            }
        } else {
            this.stateChangeHandler();
            this.snackbarHandler('Please Enter cids.', WARNING);
        }
    };

    render() {

        const {classes, theme} = this.props;
        const flex = {flexGrow: 1};

        const buttonIconStyle = {
            // marginLeft: '1em'
        };

        const checkButtonStyle = {
            marginLeft: '1em'
        };

        const containerStyle = {
            minHeight: '650px'
        };

        const contentIdInputStyle = {};

        return (
            <ErrorBoundary>
                <React.Fragment>
                    {/* {
                   this.props.supportUsers.TabsAllowed.includes()
                    && */}
                    <div className={classes.root}>

                        <Paper style={containerStyle}>
                            <br/>

                            <Grid container spacing={1}
                                  direction="row"
                                  justify="flex-start"
                                  alignContent="flex-start"
                            >

                                <Grid item sm={3}></Grid>
                                <Grid item sm={5}>
                                    <TextField style={contentIdInputStyle} fullWidth
                                               multiline
                                               rowsMax="6"
                                               rows="3"
                                               variant="outlined"
                                               label="Enter Content IDs"
                                               value={this.state.cid}
                                               onChange={this.handleChange('cid')}
                                    />
                                </Grid>


                            </Grid>
                            <br/>

                            <Grid item style={{paddingTop: '10px', paddingLeft: "27%"}}>
                                {
                                    jobCodeOptions.map(item => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.checkedItems.get(item.label)}
                                                    onChange={this.checkBoxHandleChange.bind(this)}
                                                    value={item.label}
                                                    color="primary"
                                                />
                                            }
                                            label={item.label}
                                        />
                                    ))
                                }
                            </Grid>

                            <Grid item style={{paddingTop: '10px', paddingLeft: "40%"}}>
                                {
                                    this.state.cid.trim() !== '' && this.state.checkedItems.size !== 0 ?


                                        <Grid item sm={2}>
                                            <Button variant="contained" style={checkButtonStyle} color="primary"
                                                    onClick={this.triggerTranscodingForCid.bind(this)}>
                                                Trigger Transcoding
                                            </Button>
                                        </Grid>
                                        :
                                        <Grid item sm={2} style={{paddingTop: '10px'}}>
                                            <Button variant="contained" style={checkButtonStyle} color="primary" disabled>
                                                Trigger Transcoding
                                            </Button>
                                        </Grid>
                                }

                            </Grid>
                            <br/>

                            {
                                this.state.showLoading
                                    ?
                                    <div style={{textAlign: 'center'}}>
                                        <CircularProgress className={classes.progress} color="secondary"/>
                                    </div>
                                    : null
                            }

                            <div style={{paddingTop: '30px', paddingLeft: "5%",paddingRight: "5%"}}>
                                <h3>Note</h3>
                                <p>1. Do not retrigger transcoding repeatedly has it takes time to transcode VP9 and VP6 depending upon the video size. For subtitles, it takes upto 2 minutes to process</p>
                                <p>2. If subtitles don't appear, that means they are in the queue and need to be flushed. It takes a few seconds. One can contact us, and after flushing, retriggering will work</p>
                            </div>

                        </Paper>
                    </div>
                    {/* } */}
                </React.Fragment>
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        supportUsers: state.supportUser.supportUsers
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSupportUsers: () => dispatch(getSupportUsers())
    }
};

const TranscodingTriggerToolComponent = withSnackbar(TranscodingTriggerTool);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TranscodingTriggerToolComponent));